import React, { useState, useRef } from 'react'
import { useSelector } from "react-redux";
import BudgetAllocationList from '../../../components/Multi/BudgetAllocation/BudgetAllocationList';
import { useNavigate } from 'react-router-dom';
import SubHeader from '../../../components/Subheader/Subheader';
import CustomBreadcrumbs from '../../../components/Tools/Breadcumbs';
import Stack from '@mui/material/Stack';
import Switch from '@mui/material/Switch';
import { styled } from '@mui/material/styles';

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: 'flex',
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 15,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(9px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked': {
      transform: 'translateX(12px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: '#1890ff',
        ...theme.applyStyles('dark', {
          backgroundColor: '#177ddc',
        }),
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: 'rgba(0,0,0,.25)',
    boxSizing: 'border-box',
    ...theme.applyStyles('dark', {
      backgroundColor: 'rgba(255,255,255,.35)',
    }),
  },
}));

const AllocateApprovalListPage = () => {
    const navigate = useNavigate();
    const { authData, financialYears } = useSelector((state) => state.authData);
    const [key, setKey] = useState('list');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [searchStr, setToSearchStr] = useState('');

    const fy_list = financialYears.payload.fy_list;
    const fyIdRef = useRef(localStorage.getItem('globalDateId'));
    const handleDateChange = (start, end, dateColumn, searchStr) => {
        setFromDate(start);
        setToDate(end);
        setToSearchStr(searchStr);
    };

    const handleTabSelect = (key) => {
        if (key == 'allocationList') {
            navigate('/allocate-budgets/list');
        }
    };

    const handlePageTrigger = () => {
      fyIdRef.current = localStorage.getItem('globalDateId');
    }

    const [all, setAll] = useState(false);
    const handleToggleChange = (e) => {
      let val = all === false ? true : false;
      setAll(val)
    }

    return (
        <div>
            <SubHeader fy_list={fy_list} handlePageTrigger={handlePageTrigger}/>
            {/* <ManageDisbursmentHeader onDateChange={handleDateChange} startDate={fromDate} endDate={toDate} type="Allocate Budget Approval" /> */}
            <div className='scheme p-3'>
                <div className="row" style={{ padding: "10px 16px" }}>
                  <div className="col-md-6">
                      <h4 style={{ color: "#28326f", margin:0}}>Budget Limit Approval & Allotment</h4>
                      <CustomBreadcrumbs linksArray={[]} title="Budget Limit Approval & Allotment"/>
                  </div>
                  <div className="col-md-6">
                    <div className="d-flex gap-2" style={{ width: "auto", float: "right" }}>
                        <button type="button" className="navigation_button" onClick={() => navigate("/allocate-budgets/list")}>
                            <span className="fs-14px">Budget Allocations</span>
                        </button>
                        <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                          <p>All</p>
                          <AntSwitch defaultChecked inputProps={{ 'aria-label': 'ant design' }} onChange={handleToggleChange}/>
                          <p>Pending</p>
                        </Stack>
                    </div>
                  </div>
              </div>
                <div className='scheme p-2'>
                    <BudgetAllocationList listType={key} fromDate={fromDate} toDate={toDate} searchStr={searchStr} all={all} pending={true} approval={false}/>
                    {/* <div className='all_tabs'>
                        <Tabs
                            defaultActiveKey="Allocate Budget Approval"
                            id="uncontrolled-tab-example"
                            className="mb-3"
                            activeKey={key}
                            onSelect={handleTabSelect}
                        >
                            <Tab eventKey="list" title="Budget Limit Approval & Allotment" className='p-2'>
                                <BudgetAllocationList listType={key} fromDate={fromDate} toDate={toDate} searchStr={searchStr} all={all}/>
                            </Tab>
                            <Tab eventKey="allocationList" title="Child Budget Limit Allocations" className='p-2'></Tab>
                        </Tabs>
                    </div> */}
                </div>

            </div>
        </div>
    )
}
export default AllocateApprovalListPage
